const hzUnitPricesByProduct = new Map();

function hzUpdateUnitPrice($price, productHandle, variantId, effectivePrice) {
  if (!$price.length || !productHandle || !variantId) return;

  const element = $price[0];
  const requestKey = [productHandle, variantId, effectivePrice].join(':');
  element.dataset.hzUnitRequest = requestKey;

  if (!hzUnitPricesByProduct.has(productHandle)) {
    const root = window.Shopify.routes?.root || '/';
    const request = fetch(root + 'products/' + encodeURIComponent(productHandle) + '?view=hz-unit-prices')
      .then(response => {
        if (!response.ok) throw new Error('Product price request failed');
        return response.json();
      })
      .catch(() => {
        hzUnitPricesByProduct.delete(productHandle);
        return null;
      });
    hzUnitPricesByProduct.set(productHandle, request);
  }

  hzUnitPricesByProduct.get(productHandle).then(prices => {
    if (!prices || element.dataset.hzUnitRequest !== requestKey) return;
    const measurement = prices[String(variantId)];
    $price.children('.hz-unit-price').remove();
    if (!measurement) return;

    const { amount, price, basis, unit } = measurement;
    const adjustedAmount = effectivePrice != null && price > 0
      ? Math.round(amount * effectivePrice / price)
      : amount;
    const formatted = $('<div>').html(Shopify.formatMoney(adjustedAmount, money_format)).text();
    const reference = (basis === 1 ? '' : basis + ' ') + unit.toLowerCase();
    $('<div>', { class: 'hz-unit-price', text: formatted + ' / ' + reference }).appendTo($price);
  });
}
